angular.module('dat.shared-components.location')
	.factory('LocationService', ['BaseHttpService', function (baseHttpService) {
		'use strict';

		return {
			suggestions: function(model, fnSuccess) {
				baseHttpService.post('../api/location/suggestions', model, fnSuccess, function(error) {
					console.error('get suggestions ' + error.message);
				});
			},
			resolveLocation: baseHttpService.get.bind(this)
		};
	}]);
